import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {ChangeDetectionStrategy, Component} from "@angular/core";

const debug = initDebugger('TipsKomponent');


/** For bruk i mat-select.
 *
 * <pre>
 *
 * </pre>
 */
@Component({
    selector: 'mat-select-tips',
    templateUrl: './mat-select-tips.html',
    styleUrls: ['./mat-select-tips.scss'],
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MatSelectTipsKomponent {

}
